import { defineMessages } from 'react-intl';

export const signUpPageMessages = defineMessages({
  mobileNumber: {
    id: 'text-mobile-number',
    defaultMessage: 'Mobile Number',
  },
  enterYourMobileNumber: {
    id: 'interactive-enter-mobile-number',
    defaultMessage: 'Enter your mobile number',
  },
});
